$(document).on('click', '#copy-charity-signup-link', function() {
    // Copy the text inside the text field
    navigator.clipboard.writeText($(this).attr('data-value'));

    // Alert the copied text
    $(this).text('Copied!');
})